<template>
    <VueDatePicker
        menu-class-name="custom-date-picker"
        id="playlist-interval"
        :locale="ru"
        timezone='utc'
        v-model="pickerValue"
        :enable-time-picker="enableTimePicker"
        :min-date="minDate"
        :action-row="{ showSelect: true, showCancel: false, selectBtnLabel: 'Выбрать' }"
        :teleport="true"
        :range="range"
        :formats="{ preview: 'dd.MM.yyyy : HH:mm', input: 'dd.MM.yyyy : HH:mm' }"
        :auto-apply="false"
        :input-attrs="{ clearable: false }"
        :time-config="{ startTime: [{ hours: 0, minutes: 0 }, { hours: 23, minutes: 59 }] }"
        @update:model-value="onDatePick">
        <template #input-icon>
            <svg class="dp__icon dp__input_icon dp__input_icons" viewBox="0 0 22 22" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path stroke="currentColor" stroke-width="1.833" stroke-linecap="round" stroke-linejoin="round"
                    d="M3.667 6.417A1.833 1.833 0 015.5 4.584h11a1.833 1.833 0 011.834 1.833v11A1.833 1.833 0 0116.5 19.25h-11a1.833 1.833 0 01-1.833-1.833v-11zm11-3.667v3.667M7.333 2.75v3.667m-3.666 3.667h14.667m-8.251 3.666H11m0 0v2.75" />
            </svg>
        </template>
    </VueDatePicker>
</template>

<script>
import { ru } from 'date-fns/locale';
import { splitDateTimeObj } from '../utilites';

export default {
    name: "DateTimePicker",

    props: {
        parentName: { type: String, default: null },
        value: { type: Array, default: () => [] },
        enableTimePicker: { type: Boolean, default: false },
        minDate: { type: String, default: null },
        range: { type: Boolean, default: false }
    },

    data() {
        return {
            ru,
            pickerValue: null,
            dateTime: {
                date: { start: '', end: '' },
                time: { start: '', end: '' }
            },
        }
    },

    computed: {
        edit() {
            if (this.parentName === 'PlaylistEditComponent') return true;
            else return false;
        }
    },

    methods: {
        onDatePick(value) {
            if (Array.isArray(value)) {
                const start = splitDateTimeObj(value[0]);
                const end = splitDateTimeObj(value[1]);
                this.dateTime = {
                    date: { start: start.date, end: end.date },
                    time: { start: start.time, end: end.time }
                };
            } else {
                const single = splitDateTimeObj(value);
                this.dateTime = {
                    date: { start: single.date, end: '' },
                    time: { start: single.time, end: '' }
                };
            }
            this.$emit('updateValue', this.dateTime);
        },
        splitDateTimeObj
    },

    watch: {
        value: {
            handler(val) {
                if (Array.isArray(val) && val.length === 2) {                    
                    this.pickerValue = [
                        new Date(val[0].replace(' ', 'T') + 'Z'),
                        new Date(val[1].replace(' ', 'T') + 'Z')
                    ]
                } else {
                    this.pickerValue = this.range ? [null, null] : null;
                }
                this.onDatePick(val);
            },
            deep: true
        }
    },

    mounted() {
        if (this.value.length) {
            this.pickerValue = this.value;
        }
    }
};
</script>

<style lang="scss">

</style>